import { memo, type ReactNode } from 'react'
import clsx from 'clsx'

export type StatusTone = 'pending' | 'success' | 'failed'

const TONE_CLASSES: Record<StatusTone, string> = {
  pending: 'bg-yellow-100 text-yellow-800',
  success: 'bg-green-100 text-green-800',
  failed: 'bg-red-100 text-red-800',
}

type StatusBadgeProps = {
  tone: StatusTone
  children: ReactNode
  testId?: string
}

export const StatusBadge = memo(function StatusBadge({
  tone,
  children,
  testId,
}: StatusBadgeProps) {
  return (
    <span
      className={clsx(
        'inline-flex shrink-0 items-center rounded-full px-2.5 py-0.5 text-xs font-medium',
        TONE_CLASSES[tone]
      )}
      data-testid={testId}
    >
      {children}
    </span>
  )
})
